import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Flex } from 'core/ui/atoms';
import Trait from 'johari/ui/components/Trait';
import { TRAITS, MAX_TRAITS } from 'johari/api/constants';

const Traits = ({ toggleTrait, gender, traits }) => {
  const isMax = traits?.length >= MAX_TRAITS;

  return (
    <Container>
      {TRAITS.map((t, i) => {
        const isSelected = traits.includes(t);

        return (
          <Trait
            key={i}
            trait={t}
            gender={gender}
            disabled={isMax && !isSelected}
            isSelected={isSelected}
            toggleTrait={() => toggleTrait(t)}
          />
        );
      })}
    </Container>
  );
};

const Container = styled(Flex)`
  width: 100%;
  flex-wrap: wrap;
  max-width: 1040px;
`;

Traits.propTypes = {
  toggleTrait: PropTypes.func,
  gender: PropTypes.string,
  traits: PropTypes.arrayOf(PropTypes.string),
};

export default Traits;
